export default __webpack_public_path__ + "static/react-native-5ae31a2ac59034baabd828961b3794b7.png";